// import * as os from "os";
// import * as path from "path";

import { json2xml } from "xml-js";
import xml_formatter from "xml-formatter";

// import * as logHelper from "./logHelper";

import { CsJsonObject } from "../models.helper/CsJsonObject";

function convertCsJsonObjectToXML(jsonObject: CsJsonObject) {
  return convertJsonStringToXML(JSON.stringify(jsonObject));
}

function convertJsonStringToXML(jsonString: string) {
  return json2xml(jsonString, { compact: true });
}

function formatXMLString(xmlString: string): string {
  const options = {
    indentation: "  ",
    stripComments: true,
    collapseContent: true,
    lineSeparator: "\n",
  };
  return xml_formatter(xmlString, options);
}

function isXMLString(stringToCheck: string): boolean {
  let result = false;

  try {
    if (stringToCheck != null) {
      result = stringToCheck.trim().startsWith("<?xml");
    }
    return result;
  } catch (e) {
    return result;
  }
}

export {
  convertCsJsonObjectToXML,
  convertJsonStringToXML,
  formatXMLString,
  isXMLString,
};
